import React, { useEffect, useMemo, useState } from "react";
import { userType } from "../../../data/StaticData";
import { Dropdown } from "../../../components/Dropdown";
import indiaData from "../../../data/stateData.json"; // states + districts JSON
import { apiGet } from "../../../services/apiServices";
import { endPoints } from "../../../configs/apiUrls";
import { Button } from "../../../components/Button";
import { useDispatch, useSelector } from "react-redux";
import { setFiletrData } from "../../../redux/slices/Users/slice";
import { RootState } from "../../../redux/store";

const areaOptions = [
  { label: "Koramangala", value: "Koramangala" },
  { label: "Andheri", value: "Andheri" },
];

const initialFilterState = {
  userType: null as string | null,
  state: null as string | null,
  city: null as string | null,
};

const FilterForm = ({
  tableRef
}: any) => {
  const dispatch: any = useDispatch()
  const {
    filterData,
  } = useSelector((state: RootState) => state.users)
  const [filters, setFilters] = useState(initialFilterState);
  const [areaOptions, setAreaOptions] = useState([])


  const onFilterChange = (field: string, value: string | null) => {
    // When state changes, clear city and area
    if (field === "state") {
      setFilters((prev) => ({ ...prev, state: value, city: null }));
      return;
    }
    // When city changes, clear area
    if (field === "city") {
      setFilters((prev) => ({ ...prev, city: value }));
      return;
    }
    // Normal set for other fields
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    setFilters({
      userType: filterData.userType,
      state: filterData.state,
      city: filterData.city,
    })
  }, [])


  const stateOptions = useMemo(
    () => indiaData.map((s) => ({ label: s.state, value: s.state })),
    []
  );

  // Filter city options based on selected state
  const cityOptions = useMemo(() => {
    if (!filters.state) return [];
    const stateObj = indiaData.find((s) => s.state === filters.state);
    if (!stateObj) return [];
    return stateObj.districts.map((d) => ({
      label: d,
      value: d,
      state: stateObj.state,
    }));
  }, [filters.state]);

  const handleFilter = () => {
    dispatch(setFiletrData({
      ...filterData,
      ...filters
    }))
    if (tableRef.current) {
      tableRef.current.closeFilterDrawer();
    }
  };

  const handleClear = () => {
    dispatch(setFiletrData({
      ...filterData,
      userType: "",
      state: "",
      city: "",
    }))
    setFilters(initialFilterState);
    if (tableRef.current) {
      tableRef.current.closeFilterDrawer();
    }
  };

  return (
    <div className="h-full flex flex-col p-4">
      <div className="flex-grow overflow-auto">
        <div className="flex flex-col gap-4">
          <div className="grid grid-cols-1 gap-4">
            {/* <div>
              <label className="block text-sm font-medium text-subTitleText mb-1">User Type</label>
              <Dropdown
                options={userType}
                value={filters.userType}
                onChange={(val: string | null) => onFilterChange("userType", val)}
                placeholder="Select user type"
                className="w-full"
              /> */}
            {/* </div> */}
            <div>
              <label className="block text-sm font-medium text-subTitleText mb-1">State</label>
              <Dropdown
                options={stateOptions}
                value={filters.state}
                onChange={(val: string | null) => onFilterChange("state", val)}
                placeholder="Select state"
                className="w-full"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-subTitleText mb-1">City</label>
              <Dropdown
                options={cityOptions}
                value={filters.city}
                onChange={(val: string | null) => onFilterChange("city", val)}
                placeholder="Select city"
                disabled={!filters.state}
                className="w-full"
              />
            </div>

            <div>

            </div>
          </div>
        </div>
      </div>
      {/* Fixed footer buttons */}
      <div className="border-t pt-4 flex justify-end gap-3 bg-white flex-shrink-0">
        <Button onClick={handleClear} variant="outline">
          Clear
        </Button>
        <Button onClick={handleFilter}>Filter</Button>
      </div>
    </div>
  );
};

export default FilterForm;
